import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ElementMixin, HandleDirective } from 'vue-slicksort';
let SortableItem = class SortableItem extends Vue {
    onClick() {
        this.$emit("select");
    }
};
tslib_1.__decorate([
    Prop({ type: Object, default: () => { } })
], SortableItem.prototype, "item", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], SortableItem.prototype, "selected", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], SortableItem.prototype, "highLevel", void 0);
SortableItem = tslib_1.__decorate([
    Component({
        name: 'SortableItem',
        mixins: [ElementMixin],
        directives: {
            handle: HandleDirective
        }
    })
], SortableItem);
export default SortableItem;
